import { Navigate, Outlet } from "react-router-dom";
import Paths from "../constants/paths";
import Navbar from "../components/navbar/Navbar";
import { getDefaultPagePerRoleBo } from "../lib/roleBasedDefaultPage";
import { useAtomValue } from "jotai";
import { userAtom } from "@/stores/authStore";

export const ProtectedRoute = () => {
  const user = useAtomValue(userAtom);

  if (!user) {
    return <Navigate to={Paths.auth.login} />;
  }
  if (user.isBoUser) {
    return <Navigate to={getDefaultPagePerRoleBo(user.role || undefined)} />;
  }

  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-gray-50 md:flex-row">
      <Navbar role={user.role || undefined} />
      <div className="flex flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};
